/**
 * 获取天地图经纬度
 * @param {Vue} vueInstance 服务
 * @param {string} address 请求参数
 * @returns {Promise<{lat: number, lng: number}>} 经纬度
 */
export const getLatAndLng = (vueInstance, address) => {
  return new Promise((resolve, reject) => {
    const requestUrl = 'tianditu/geocoder'
    vueInstance.getHttpServices().getBaseService().get(requestUrl, { address: address })
      .then(data => {
        resolve({ ...data, lng: data.lon })
      })
      .catch(err => {
        reject(err)
      })
  })
}
/**
 * 获取天地图经纬度
 * @param {Vue} vueInstance 服务
 * @param {number} lat 纬度
 * @param {number} lng 经度
 * @returns {Promise<{lat: number, lng: number}>} 经纬度
 */
export const getAddressByLatAndLng = (vueInstance, lat, lng) => {
  return new Promise((resolve, reject) => {
    const requestUrl = 'tianditu/reverseGeocode'
    vueInstance.getHttpServices().getBaseService().get(requestUrl, {
      lon: lng,
      lat: lat
    })
      .then(data => {
        resolve(data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
export const parserAddress = (selectOptions, address) => {
  if (selectOptions.length > 0) {
    return selectOptions.filter(item => String(item.value) !== '0' && String(item.value) !== '1').map(item => item.label).join('') + address
  }
  return address
}